import { ComponentType, ReactElement, SVGProps } from 'react';
import { tokens } from '../../theme';
import { useIsDesktop } from '../../hooks';

const MOBILE_ICON_SIZE = 16;
const DESKTOP_ICON_SIZE = 24;
const MOBILE_GAP = 4;
const DESKTOP_GAP = 8;

type RequestTypeBadgeProps = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
};

export const RequestTypeBadge = ({ icon: Icon, label }: RequestTypeBadgeProps): ReactElement => {
  const isDesktop = useIsDesktop();

  return (
    <div
      style={{
        ...styles.badge,
        gap: isDesktop ? DESKTOP_GAP : MOBILE_GAP,
        padding: isDesktop
          ? `${tokens.spacing.tiny} ${tokens.spacing.smaller}`
          : tokens.spacing.tiny,
      }}
    >
      <Icon
        width={isDesktop ? DESKTOP_ICON_SIZE : MOBILE_ICON_SIZE}
        height={isDesktop ? DESKTOP_ICON_SIZE : MOBILE_ICON_SIZE}
        aria-hidden="true"
        focusable="false"
      />
      <p style={styles.label}>{label}</p>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  badge: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: tokens.colors.global.white,
    borderRadius: tokens.radius.small,
    width: 'fit-content',
  },
  label: {
    margin: tokens.spacing.none,
    fontSize: tokens.typography.fontSize.badge,
    fontWeight: tokens.typography.fontWeight.medium,
    color: tokens.colors.global.black,
    whiteSpace: 'nowrap',
  },
};
